import React, { useEffect, useState } from 'react';
import { Jumbotron, ListGroup, Button, Modal, ModalHeader, ModalBody, ModalFooter, ListGroupItem, Form, FormGroup, Label, Input } from 'reactstrap';
import { withApollo } from 'react-apollo';
import { GET_TAGS } from '../../query/query';
import { CREATE_TAG } from '../../mutation/mutation';
import Tag from './tag';

const getTags = async (client, setter) => {
  return client.query({
    query: GET_TAGS,
    fetchPolicy: 'network-only',
  }).then(({ data }) => {
    if (data.tags) {
      setter(data.tags);
    }
  }).catch((err) => {
    console.log('catch', err);
    alert(err);
  });
};

const createTag = async (client, data) => {
  return client.mutate({
    mutation: CREATE_TAG,
    variables: data,
  }).catch((err) => {
    console.log('catch', err);
    alert(err);
  });
};

const TagsPage = ({ client: apolloClient }) => {
  const [tags, setTags] = useState([]);
  const [modal, setModal] = useState(false);
  const [newTag, setNewTag] = useState({ rank: 1 });

  const toggle = () => setModal(!modal);

  useEffect(() => {
    getTags(apolloClient, setTags);
  }, []);

  return (
    <Jumbotron>
      <h3 className="display-4">
          Tags
      </h3>
      <Button color="success" onClick={toggle}>Nouveau Tag</Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Nouveau Tag</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Titre anglais</Label>
              <Input
                onChange={({ target: { value } }) => setNewTag({ ...newTag, titleEn: value })}
                value={newTag.titleEn}
              />
            </FormGroup>
            <FormGroup>
              <Label>Titre français</Label>
              <Input
                onChange={({ target: { value } }) => setNewTag({ ...newTag, titleFr: value })}
                value={newTag.titleFr}
              />
            </FormGroup>
            <FormGroup>
              <Label>Rang</Label>
              <Input
                onChange={({ target: { value } }) => setNewTag({ ...newTag, rank: +value })}
                value={newTag.rank}
                type="number"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={async () => {
            await createTag(apolloClient, newTag);
            getTags(apolloClient, setTags);
            toggle();
          }}>
            Valider
          </Button>
        </ModalFooter>
      </Modal>
      <hr className="my-2" />
      <ListGroup>
        {tags.map((tag) => (
          <ListGroupItem key={`tag_${tag._id}`}>
            <Tag apolloClient={apolloClient} tag={tag} onDelete={() => getTags(apolloClient, setTags)}/>
          </ListGroupItem>
        ))}
      </ListGroup>
    </Jumbotron>
  );
};

export default withApollo(TagsPage);



// WEBPACK FOOTER //
// ./src/components/tags/tags.js